import React from 'react'

import { SmallLoader } from '@/grove/components'

/**
 * Button.Loader Component
 *
 * A loader component designed to be used as a child of Button.
 *
 * Usage Examples:
 * <Button intent={"primary" }type="button"><Button.Loader variant={"light"} /></Button>
 * <Button intent={"secondary-dark"} type="button"><Button.Loader variant={"dark"} /></Button>
 */
export function ButtonLoader({
  variant,
}: {
  readonly variant: 'light' | 'dark'
}) {
  return <SmallLoader variant={variant} />
}
